var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-control-product-types-features-container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_setup.items, function (item, index) {
        return _c(
          "div",
          {
            key: "feature-row-" + index,
            staticClass: "mb-3 list-group border shadow-sm rounded",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "list-group-item small pe-0 d-flex align-items-start border-0",
              },
              [
                _c("div", { staticClass: "flex-fill me-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.name,
                        expression: "item.name",
                      },
                    ],
                    staticClass: "mb-2 form-control form-control-sm fw-bold",
                    attrs: {
                      name: "name",
                      placeholder: "Feature name (e.g., Size, Material)",
                      required: "",
                      autofocus: index === _setup.items.length - 1,
                    },
                    domProps: { value: item.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(item, "name", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.options,
                        expression: "item.options",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    attrs: {
                      name: "options",
                      placeholder:
                        "Comma-separated choices (e.g., Small, Medium, Large)",
                    },
                    domProps: { value: item.options },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(item, "options", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1, true),
                ]),
                _vm._v(" "),
                _c(
                  _setup.Button,
                  {
                    staticClass:
                      "m-1 btn-sm p-1 lh-1 text-danger hover-opacity-1",
                    attrs: { "default-class": "btn-link" },
                    nativeOn: {
                      click: function ($event) {
                        return _setup.removeFeatureField(index)
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-x-lg" })]
                ),
              ],
              1
            ),
          ]
        )
      }),
      _vm._v(" "),
      _c(
        _setup.Button,
        {
          staticClass: "btn-sm mt-1",
          nativeOn: {
            click: function ($event) {
              return _setup.addFeatureField.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "bi bi-plus-lg me-1" }),
          _vm._v(" Add feature\n    "),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "alert alert-warning py-2 small border-0 shadow-sm mb-3" },
      [
        _vm._v(
          "\n        Changes to a type’s features may affect existing products of that type.\n        "
        ),
        _c("br"),
        _vm._v(
          "\n        It is recommended to review all product features after making changes.\n    "
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "form-text text-muted mt-1 small ms-1" }, [
      _c("em", [
        _vm._v(
          "Enter a comma-delimited list of options E.g. Size, Colour etc."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }